module.exports = __webpack_public_path__ + "img/about-intro-2.706166bc.png";